import apiFetch from '../apiFetch'

export default function (token, saleTypeId) {
  return apiFetch({ endPoint: `SaleType/${saleTypeId}`, method: 'DELETE', body: null, token: token })
}
